import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { useAvailableApartments } from "../../components/ApartmentFinder/Utils/hooks"
import setActiveLights from "../../state/lights"
import { useStore } from "../../state/store"

export default function LightsBroadcaster() {
  const available = useAvailableApartments()
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const location = useLocation().pathname
  useEffect(() => {
    /**
     * Change the lights if the apartment finder mode is toggled or if the
     * filter state changes.
     */
    if (apartmentFinderActive || location.includes("favourites")) {
      setActiveLights(available.map(a => a.PlotNumberPlanning))
      // setActiveLights(available.map(a => a.PlotNumberPlanning))
    } else {
      setActiveLights(["ALL"])
    }
  }, [available, apartmentFinderActive])

  return <div />
}
